import React from 'react'
import { Container, Row, Col } from 'react-bootstrap';
import Meta from '../../../components/Meta';
import { SUPPORT_EMAIL } from '../../../constants/constants';

const FAQ = () => {
  return (
    <>
        <Meta>
            title='よくある質問について | ふるぷら'
            description='ふるぷらを利用する上で、お客様がよくされる質問について回答するページです。'
            keywords={['ふるぷら', '古着', 'レンタル', 'よくある質問']}
        </Meta>
        <Container className="my-5">
            <Row className='justify-content-center'>
                <Col xs={12} md={8} lg={5}>
                    <section className='faqtop-1'>
                        <h1 className="fs-3 mb-4 text-center">よくある質問について</h1>
                            <h2 className='fs-5 fw-bold text-primary'> Q.古着はどんなコンディションで届きますか？</h2>
                                <p>A.すべての商品は、加盟している古着屋さんによる検品・クリーニング済みです。<br />
                                古着特有の味わいや多少の使用感がある場合もありますが、問題なくご着用いただけるもののみ取り扱っています。</p><br />
                            <h2 className='fs-5 fw-bold text-primary'>Q.レンタルしたアイテムをそのまま購入することはできますか？</h2>
                                <p>
                                    A.はい、可能です！<br />
                                    レンタル期間中の購入は、定価の割引価格で行えます！<br />
                                    レンタル期間中に【プロフィール】＞＞【返却期限が近い商品】＞＞購入したい商品の【確認する】をクリック。<br />
                                    そうすると「購入する」ボタンが表示されます。このボタンを押すだけで、購入手続きができます。<br />
                                    ※別途購入料金が必要です。<br />
                                </p>
                            <h2 className='fs-5 fw-bold text-primary'>Q.レンタル期間はどのくらいですか。</h2>
                                <p>
                                    A.単発レンタルの場合は7日間、サブスクリプションプランの場合は1ヶ月ごとのご利用となります。<br />
                                    延長も可能ですので、詳しくは【使い方ガイド】＞＞【料金・お支払】をご確認ください。<br />
                                </p>
                            <h2 className='fs-5 fw-bold text-primary'>Q.返却時にクリーニングは必要ですか。</h2>
                                <p>
                                    A.クリーニングは不要です！<br />
                                    通常の使用による汚れは当社で対応しますので、そのままご返却ください。<br />
                                </p>
                            <h2 className='fs-5 fw-bold text-primary'>Q.どんなブランドやショップの古着を扱っていますか？</h2>
                                <p>
                                    A.下北沢の人気古着店5店舗と提携しており、カジュアル、ヴィンテージ、ミリタリー、ストリート系など幅広いジャンルを取り揃えています。<br />
                                    提携店舗一覧は[こちら]（リンク）からご確認いただけます！<br />
                                </p>
                            <h2 className='fs-5 fw-bold text-primary'>Q.サブスクリプションプランは途中解約できますか？</h2>
                                <p>
                                    A.いつでも解約可能です。<br />
                                    ただし、次回更新日前日までにプロフィールから解約手続きを行ってください。<br />
                                    期間途中の返金は承っておりませんのでご了承ください。<br />
                                </p>
                            <h2 className='fs-5 fw-bold text-primary'>Q.サイズが合わなかった場合、交換できますか？</h2>
                                <p>
                                    A.申し訳ありませんが、サイズ違いによる交換は原則承っておりません。<br />
                                    ご注文前に商品ページのサイズ詳細を必ずご確認ください。<br />
                                    もし、ご不安な点がございましたら、レンタル・購入前に
                                    <a
                                        href={`mailto:${SUPPORT_EMAIL}`}
                                        style={{ marginLeft: '0.5rem', color: '#0070f3' }}
                                    >
                                        {SUPPORT_EMAIL}
                                    </a>
                                    にお問い合わせください。<br />
                                </p>
                            <h2 className='fs-5 fw-bold text-primary'>Q.破損・汚損・紛失した場合はどうなりますか？</h2>
                                <p>
                                    A.通常使用による軽微なダメージは問題ありません。<br />
                                    大きな破損・汚損が発生した場合は、別途修繕費や弁償費用をご請求する場合がありますのでご注意ください。<br />
                                    また、紛失した場合は、定価を別途支払いただきます。<br />
                                </p>
                    </section>
                </Col>
            </Row>
        </Container>
        </>

  )
}

export default FAQ